import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { iconWidth } from './CardFooterIcon';
var propTypes = {
  children: PropTypes.oneOfType([PropTypes.node.isRequired, PropTypes.arrayOf(PropTypes.node).isRequired]).isRequired
};
var CardFooterIcons = styled.div.withConfig({
  displayName: "CardFooterIcons",
  componentId: "hattqr-0"
})(["margin-right:auto;margin-left:auto;", ""], function (props) {
  var numChildren = React.Children.toArray(props.children).filter(function (c) {
    return c != null;
  }).length;
  return css(["width:", "px;"], iconWidth * numChildren);
});
CardFooterIcons.propTypes = propTypes;
export default CardFooterIcons;